import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import QuickEntrySection from "@/pages/home/components/QuickEntrySection";
import AddressSection from "@/pages/home/components/AddressSection";
import DownloadSection from "@/pages/home/components/DownloadSection";
import GuideSection from "@/pages/home/components/GuideSection";
import ZonesSection from "@/pages/home/components/ZonesSection";
import DeviceSection from "@/pages/home/components/DeviceSection";
import FaqSection from "@/pages/home/components/FaqSection";
import SafetySection from "@/pages/home/components/SafetySection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <QuickEntrySection />
        <AddressSection />
        <DownloadSection />
        <GuideSection />
        <ZonesSection />
        <DeviceSection />
        <FaqSection />
        <SafetySection />
      </main>
      <SiteFooter />
    </div>
  );
}